import moment from 'moment'

export default function (value) {
    return value ? moment(value.toString()).format('MMMM D, YYYY h:mm a') : ''
}
